module.exports = __webpack_public_path__ + "img/8.7f59cc5e.png";